import notificationsConfig, { unknownName } from "./notificationsConfig";

export const priorityValues = {
    success: 0,
    info: 1,
    recommendation: 2,
    warning: 3,
    error: 4,
    failed: 5,
    critical: 6
};

export const compareNotifications = (a, b) => {
    const aIsCritical = a?.priority === "critical";
    const bIsCritical = b?.priority === "critical";

    if (aIsCritical !== bIsCritical) {
        return Number(bIsCritical) - Number(aIsCritical);
    }

    return Number(b?.timestamp || 0) - Number(a?.timestamp || 0);
};

const parseErrors = (rawErrors) => {
    if (!rawErrors) {
        return null;
    }
    try {
        const parsedErrors = JSON.parse(rawErrors);
        if (Array.isArray(parsedErrors) && parsedErrors.length) {
            return parsedErrors;
        }
        return [rawErrors];
    } catch {
        return [rawErrors];
    }
};

export const processNotificationPayload = (payload) => {
    if (!payload?.action || !payload?.timestamp || !payload?.priority || !payload?.service) {
        return null;
    }

    if (!Object.prototype.hasOwnProperty.call(priorityValues, payload.priority)) {
        return null;
    }

    const params = payload.params ? { ...payload.params } : {};
    const localPayload = {
        ...payload,
        params
    };

    let labels = {
        action: `${payload.action}`
    };

    const config = notificationsConfig[payload.service]?.[payload.action];
    if (config) {
        const resourceName = config.getResourceName({ payload: localPayload });
        if (resourceName === unknownName) {
            if (!params.resourceName) {
                params.resourceName = unknownName;
            }
        } else {
            params.resourceName = resourceName;
        }
        labels = config.getLabels({ payload: localPayload });
    }

    const priority = payload.priority === "failed" ? "error" : payload.priority;
    const errors = parseErrors(payload.errors);

    let descriptions = [];
    if (priority === "error" && errors) {
        descriptions = errors;
    } else if (priority !== "error" && payload.description) {
        descriptions = [payload.description];
    }

    return {
        stored: payload.stored,
        notificationId: payload.notificationId || null,
        id: payload.id,
        label: labels?.action || payload.action,
        timestamp: payload.timestamp,
        priority,
        service: payload.service,
        descriptions,
        cta: payload.cta,
        link: payload.link
    };
};